<template>
  <page :title="title">
      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div><v-icon>mdi-filter-variant</v-icon> Date Range</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
    <v-container fluid grid-list-md>
      <v-card>
        <v-card-text>
          <v-layout row wrap align-center>
            <v-flex xs12 sm4>
              <cal-picker
                v-model="form.tranDateFrom"
                :label="labels.tranDateFrom"
                :data-vv-as="labels.tranDateFrom"
                data-vv-name="form.tranDateFrom"
                :error-messages="errors.collect('form.tranDateFrom')"
                v-validate="doValidateTranDateFrom"
                :max="new Date()"
              />
            </v-flex>
            <v-flex xs12 sm4>
              <cal-picker
                v-model="form.tranDateTo"
                :label="labels.tranDateTo"
                :data-vv-as="labels.tranDateTo"
                data-vv-name="form.tranDateTo"
                :error-messages="errors.collect('form.tranDateTo')"
                v-validate="doValidateTranDateTo"
                :max="new Date()"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-3"></v-spacer>
      <v-expansion-panels v-model="panel2" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div><v-icon>mdi-filter-variant</v-icon> Selection Criteria</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
    <v-container fluid grid-list-md>
      <v-card>
        <v-card-text>
          <v-layout row wrap align-center>
            <v-flex xs12 class="ma-0 pa-0" />
            <v-flex xs12 sm4>
              <v-autocomplete
                :items="accumTypes"
                v-model="form.accumType"
                v-validate="'required'"
                clearable
                :label="labels.accumType"
                item-text="label"
                item-value="accmType"
                data-vv-name="accumType"
                :error-messages="errors.collect('accumType')"
                :data-vv-as="labels.accumType"
                @change="accumTypeChanged"
              />
            </v-flex>
            <v-flex xs12 class="ma-0 pa-0" />
            <v-flex xs12 sm4>
              <v-text-field
                :loading="loading"
                :disabled="!enableBlkGrp"
                v-model="form.blkGrpFrom"
                :label="labels.blkGrpFrom"
                :error-messages="errors.collect('blkGrpFrom')"
                data-vv-name="blkGrpFrom"
                :data-vv-as="labels.blkGrpFrom"
                append-icon="mdi-magnify"
                @click:append="showHelpList('blkGrpFrom')"
                clearable
                @click:clear="blkGrpChanged"
              />
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
                :loading="loading"
                :disabled="!enableBlkGrp"
                v-model="form.blkGrpTo"
                :label="labels.blkGrpTo"
                :error-messages="errors.collect('blkGrpTo')"
                data-vv-name="blkGrpTo"
                :data-vv-as="labels.blkGrpTo"
                append-icon="mdi-magnify"
                @click:append="showHelpList('blkGrpTo')"
                clearable
                @click:clear="blkGrpChanged"
              />
            </v-flex>
            <v-flex xs12 class="ma-0 pa-0" />
            <v-flex xs12 sm4>
              <v-text-field
                :loading="loading"
                :disabled="!enableBlkSubGrp1"
                v-model="form.blkSubGrp1From"
                :label="labels.blkSubGrp1From"
                :error-messages="errors.collect('blkSubGrp1From')"
                data-vv-name="blkSubGrp1From"
                :data-vv-as="labels.blkSubGrp1From"
                append-icon="mdi-magnify"
                @click:append="showHelpList('blkSubGrp1From')"
                clearable
                @click:clear="blkSGrp1Changed"
              />
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
                :loading="loading"
                :disabled="!enableBlkSubGrp1"
                v-model="form.blkSubGrp1To"
                :label="labels.blkSubGrp1To"
                :error-messages="errors.collect('blkSubGrp1To')"
                data-vv-name="blkSubGrp1To"
                :data-vv-as="labels.blkSubGrp1To"
                append-icon="mdi-magnify"
                @click:append="showHelpList('blkSubGrp1To')"
                clearable
                @click:clear="blkSGrp1Changed"
              />
            </v-flex>
            <v-flex xs12 class="ma-0 pa-0" />
            <v-flex xs12 sm4>
              <v-text-field
                :loading="loading"
                :disabled="!enableBlkSubGrp2"
                v-model="form.blkSubGrp2From"
                :label="labels.blkSubGrp2From"
                :error-messages="errors.collect('blkSubGrp2From')"
                data-vv-name="blkSubGrp2From"
                :data-vv-as="labels.blkSubGrp2From"
                append-icon="mdi-magnify"
                @click:append="showHelpList('blkSubGrp2From')"
                clearable
                @click:clear="blkSGrp2Changed"
              />
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
                :loading="loading"
                :disabled="!enableBlkSubGrp2"
                v-model="form.blkSubGrp2To"
                :label="labels.blkSubGrp2To"
                :error-messages="errors.collect('blkSubGrp2To')"
                data-vv-name="blkSubGrp2To"
                :data-vv-as="labels.blkSubGrp2To"
                append-icon="mdi-magnify"
                @click:append="showHelpList('blkSubGrp2To')"
                clearable
                @click:clear="blkSGrp2Changed"
              />
            </v-flex>
            <v-flex xs12 class="ma-0 pa-0" />
            <v-flex xs12 sm4>
              <v-text-field
                :loading="loading"
                :disabled="!enableBlk"
                v-model="form.blkFrom"
                :label="labels.blkFrom"
                :error-messages="errors.collect('blkFrom')"
                data-vv-name="blkFrom"
                :data-vv-as="labels.blkFrom"
                append-icon="mdi-magnify"
                @click:append="showHelpList('blkFrom')"
                clearable
              />
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
                :loading="loading"
                :disabled="!enableBlk"
                v-model="form.blkTo"
                :label="labels.blkTo"
                :error-messages="errors.collect('blkTo')"
                data-vv-name="blkTo"
                :data-vv-as="labels.blkTo"
                append-icon="mdi-magnify"
                @click:append="showHelpList('blkTo')"
                clearable
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    <v-spacer class="mt-3"></v-spacer>
    <v-btn color="primary" @click="doSubmit" :loading="submitting">
      <v-icon left>mdi-clipboard-check-outline</v-icon>
      {{ labels.normalise }}
    </v-btn>
    <v-dialog v-model="dialogBlkGrp" width="900px" persistent>
      <block-group-help-list v-if="dialogBlkGrp" :accmType="form.accumType" @close="doClose" @assign-blkGrp="doAssign($event)" />
    </v-dialog>
    <v-dialog v-model="dialogBlkSubGrp1" width="900px" persistent>
      <block-sub-group-1-help-list
        v-if="dialogBlkSubGrp1"
        :accmType="form.accumType"
        :blkGrpFrm="form.blkGrpFrom"
        :blkGrpTo="form.blkGrpTo"
        @close="doClose"
        @assign-blksGrp1="doAssign($event)"
      />
    </v-dialog>
    <v-dialog v-model="dialogBlkSubGrp2" width="900px" persistent>
      <block-sub-group-2-help-list
        v-if="dialogBlkSubGrp2"
        :accmType="form.accumType"
        :blkGrpFrm="form.blkGrpFrom"
        :blkGrpTo="form.blkGrpTo"
        :blksGrp1Frm="form.blkSubGrp1From"
        :blksGrp1To="form.blkSubGrp1To"
        @close="doClose"
        @assign-blksGrp2="doAssign($event)"
      />
    </v-dialog>
    <v-dialog v-model="dialogBlk" width="900px" persistent>
      <block-help-list
        v-if="dialogBlk"
        :accmType="form.accumType"
        :blkGrpFrm="form.blkGrpFrom"
        :blkGrpTo="form.blkGrpTo"
        :blksGrp1Frm="form.blkSubGrp1From"
        :blksGrp1To="form.blkSubGrp1To"
        :blksGrp2Frm="form.blkSubGrp2From"
        :blksGrp2To="form.blkSubGrp2To"
        @close="doClose"
        @assign-blk="doAssign($event)"
      />
    </v-dialog>

    <v-dialog v-model="promptExeJob" width="500px" persistent>
        <batch-job-scheduler
          v-if="promptExeJob"
          :skipValidate="batchForm.skipValidate"
          :jobKeys="form"
          :showJobMode="false"
          @close="promptExeJob = false"
          @doPopulate="processBatch($event)"
        />
      </v-dialog>

    <warning v-model="promptResubmit" @ok="doAccept">
      <div>{{ warningMsg1 }}</div>
      <div class="queryValue" v-for="(item, index) in bchJobDetails" :key="index">{{ item }}</div>
      <div>{{ warningMsg2 }}</div>
    </warning>
  </page>
</template>
<script>
import BlockGroupHelpList from '@/components/core/common/dialog/BlockGroupHelpList'
import BlockSubGroup1HelpList from '@/components/core/common/dialog/BlockSubGroup1HelpList'
import BlockSubGroup2HelpList from '@/components/core/common/dialog/BlockSubGroup2HelpList'
import BlockHelpList from '@/components/core/common/dialog/BlockHelpList'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import BatchJobScheduler from '@/components/core/common/BatchJobScheduler'
import { batchManagerMixin } from '@/mixins/common/batchManagerMixin'

export default {
  components: {
    BlockGroupHelpList,
    BlockSubGroup1HelpList,
    BlockSubGroup2HelpList,
    BlockHelpList,
    BatchJobScheduler
  },
  mixins: [commonAjaxMixin, batchManagerMixin],
  data() {
    return {
      title: 'Block Normalisation',
      loading: false,
      submitting: false,
      form: {
        action: undefined,
        tranDateFrom: new Date(),
        tranDateTo: new Date(),
        accumType: undefined,
        blkGrpFrom: undefined,
        blkGrpTo: undefined,
        blkSubGrp1From: undefined,
        blkSubGrp1To: undefined,
        blkSubGrp2From: undefined,
        blkSubGrp2To: undefined,
        blkFrom: undefined,
        blkTo: undefined
      },
      labels: {
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        accumType: 'Accumulation Type',
        blkGrpFrom: 'Block Group From',
        blkGrpTo: 'Block Group To',
        blkSubGrp1From: 'Block Sub Group 1 From',
        blkSubGrp1To: 'Block Sub Group 1 To',
        blkSubGrp2From: 'Block Sub Group 2 From',
        blkSubGrp2To: 'Block Sub Group 2 To',
        blkFrom: 'Block From',
        blkTo: 'Block To',
        normalise: 'Normalise'
      },
      activeHelpList: false,
      dialogBlkGrp: false,
      dialogBlkSubGrp1: false,
      dialogBlkSubGrp2: false,
      dialogBlk: false,
      blkSubGrp2s: [],
      blks: [],
      panel: [0],
      panel2: [0]
    }
  },
  created() {
    this.$validator.extend('valMaxDate', {
      getMessage(field, args) {
        return 'Cannot be later than System Date'
      },
      validate(value, args) {
        let maxDate = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(maxDate))
        } else return true
      }
    })
    this.$validator.extend('valMinDate', {
      getMessage(field, args) {
        return 'Cannot be earlier than From Date'
      },
      validate(value, args) {
        let mixDate = args[0]
        if (value) {
          return !isAfter(removeTime(mixDate), removeTime(value))
        } else return true
      }
    })
  },
  mounted() {
    if (this.$store.state.blkParam.init !== 1) {
      this.$store.dispatch('blkParamManagementInit')
    }
    this.$store.dispatch('nts_loadAccumTypes')
  },
  methods: {
    accumTypeChanged() {
      this.form.blkGrpFrom = undefined
      this.form.blkGrpTo = undefined
      this.blkGrpChanged()
    },
    blkGrpChanged() {
      this.form.blkSubGrp1From = undefined
      this.form.blkSubGrp1To = undefined
      this.blkSGrp1Changed()
    },
    blkSGrp1Changed() {
      this.form.blkSubGrp2From = undefined
      this.form.blkSubGrp2To = undefined
      this.blkSGrp2Changed()
    },
    blkSGrp2Changed() {
      this.form.blkFrom = undefined
      this.form.blkTo = undefined
    },
    showHelpList(field) {
      this.activeHelpList = field
      if (this.activeHelpList === 'blkGrpFrom' || this.activeHelpList === 'blkGrpTo') {
        this.dialogBlkGrp = true
      } else if (this.activeHelpList === 'blkSubGrp1From' || this.activeHelpList === 'blkSubGrp1To') {
        this.dialogBlkSubGrp1 = true
      } else if (this.activeHelpList === 'blkSubGrp2From' || this.activeHelpList === 'blkSubGrp2To') {
        this.dialogBlkSubGrp2 = true
      } else if (this.activeHelpList === 'blkFrom' || this.activeHelpList === 'blkTo') {
        this.dialogBlk = true
      }
    },
    doAssign(val) {
      if (this.activeHelpList === 'blkGrpFrom') {
        this.form.blkGrpFrom = val
        this.blkGrpChanged()
      } else if (this.activeHelpList === 'blkGrpTo') {
        this.form.blkGrpTo = val
        this.blkGrpChanged()
      } else if (this.activeHelpList === 'blkSubGrp1From') {
        this.form.blkSubGrp1From = val
        this.blkSGrp1Changed()
      } else if (this.activeHelpList === 'blkSubGrp1To') {
        this.form.blkSubGrp1To = val
        this.blkSGrp1Changed()
      } else if (this.activeHelpList === 'blkSubGrp2From') {
        this.form.blkSubGrp2From = val
        this.blkSGrp2Changed()
      } else if (this.activeHelpList === 'blkSubGrp2To') {
        this.form.blkSubGrp2To = val
        this.blkSGrp2Changed()
      } else if (this.activeHelpList === 'blkFrom') {
        this.form.blkFrom = val
      } else if (this.activeHelpList === 'blkTo') {
        this.form.blkTo = val
      }
      this.activeHelpList = ''
      this.doClose()
    },
    doClose() {
      this.dialogBlkGrp = false
      this.dialogBlkSubGrp1 = false
      this.dialogBlkSubGrp2 = false
      this.dialogBlk = false
    },
    doSubmit() {
      this.promptResubmit = false
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.isBatchManager === true) {
            this.promptExeJob = true
          } else {
            this.sendRequest()
          }
        }
      })
    },
    async sendRequest() {
      const apiURI = this.menu.processNormTreatySurplus
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.$toast.success('Normalisation completed.')
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async processBatch(bmForms) {
      const apiURI = this.menu.exeNormTreatySurplus
      if (apiURI) {
        try {
          this.submitting = true
          const result = await this.$http.post(apiURI, bmForms)
          if (result.data) {
            const { data } = result.data
            if (data.prevBchJobs && data.prevBchJobs.length > 0) {
              this.promptResubmit = true
              this.getBchJobDetails(data.prevBchJobs)
            }
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  computed: {
    normTreatySurplus() {
      return this.$store.state.normTreatySurplus
    },
    menu() {
      return this.normTreatySurplus.menu
    },
    accumTypes() {
      return this.normTreatySurplus.accumTypes
    },
    accumTypeMap() {
      return this.normTreatySurplus.accumTypeMap
    },
    accumType() {
      if (this.form.accumType && this.accumTypeMap[this.form.accumType]) {
        return this.accumTypeMap[this.form.accumType]
      }
      return {}
    },
    enableBlkGrp() {
      if (this.accumType.blkGrpLblS) {
        return true
      }
      return false
    },
    enableBlkSubGrp1() {
      if (this.accumType.blksGrp1LblS) {
        return true
      }
      return false
    },
    enableBlkSubGrp2() {
      if (this.accumType.blksGrp2LblS) {
        return true
      }
      return false
    },
    enableBlk() {
      if (this.accumType.blkLblS) {
        return true
      }
      return false
    },
    doValidateTranDateFrom() {
      const today = new Date()
      return 'required|valMaxDate:' + today
    },
    doValidateTranDateTo() {
      if (this.form.tranDateFrom !== null) {
        return 'required|valMinDate:' + this.form.tranDateFrom
      } else {
        return 'required'
      }
    }
  }
}
</script>
